import { getToken } from 'firebase/messaging';
import { messaging } from '../config/firebase';

export const requestForToken = async () => {
  try {
    if (!messaging) {
      // Only warn in dev mode to avoid console noise when Firebase is intentionally disabled
      if (import.meta.env.DEV) {
        console.debug('[Firebase] Messaging not initialized - push notifications disabled');
      }
      return '';
    }

    // Check if VAPID key is configured (not placeholder or empty)
    const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;
    if (!vapidKey || vapidKey === 'placeholder' || vapidKey.length < 50) {
      // VAPID keys are ~88 characters base64 encoded
      if (import.meta.env.DEV) {
        console.debug(
          '[Firebase] Push notifications disabled: VITE_FIREBASE_VAPID_KEY not configured'
        );
      }
      return '';
    }

    const token = await getToken(messaging, {
      vapidKey,
    });

    if (token) {
      return token;
    }

    return '';
  } catch (err) {
    console.error('An error occurred while retrieving token:', err);
    return '';
  }
};

export async function checkNotificationPermission(): Promise<
  'granted' | 'denied' | 'default' | 'unsupported'
> {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    console.warn(
      'Notifications are not supported in this browser or environment.'
    );
    return 'unsupported';
  }

  try {
    const permission = Notification.permission;
    return permission;
  } catch (err) {
    console.error('Error checking notification permission:', err);
    return 'unsupported';
  }
}

export const askNotificationPermission = async (): Promise<
  'granted' | 'denied' | 'default' | 'unsupported'
> => {
  const current = await checkNotificationPermission();

  if (
    (current === 'default' || current === 'denied') &&
    'Notification' in window
  ) {
    try {
      const result = await Notification.requestPermission();
      return result;
    } catch {
      return 'denied';
    }
  }

  return current;
};
